'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove_protocol = remove_protocol;
exports.ensure_protocol = ensure_protocol;
exports.is_path_absolute = is_path_absolute;
var REGEX_HTTP_S = /^(?:http:|https:)?(?:\/\/)?/;

var STR_OSS = 'oss.thebeastshop.com';
var STR_OSS_IMG = 'img.thebeastshop.com';

// function ensure_http (url) {
//   return url.replace(REGEX_HTTP_S, 'http://').replace(STR_OSS, STR_OSS_IMG)
// }


// function ensure_https (url) {
//   return url.replace(REGEX_HTTP_S, 'https://').replace(STR_OSS, STR_OSS_IMG)
// }


function remove_protocol(url) {
  return url.replace(/http:\/\//, '//').replace(/https:\/\//, '//').replace(STR_OSS, STR_OSS_IMG);
}

// Cases:
// 'http://xxxx'
// 'https://xxxx'
// '//xxxx'
// '/xxxx'
// 'xxxx'

// You should NOT do this:
// ensure_protocol('/abc.html')
function ensure_protocol() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof url !== 'string') {
    return '';
  }
  if (url.trim() === '') {
    return url;
  }
  return url.replace(REGEX_HTTP_S, location.protocol + '//').replace(STR_OSS, STR_OSS_IMG);
}

var REGEX_ABS_PATH = /^\/(?:[^/]|$)/;

function is_path_absolute(pathname) {
  return REGEX_ABS_PATH.test(pathname);
}

// - js-bridge:
//   - image: ensure_protocol
//   - ajax
//     - absolute path: remain no touched
//     - url: ensure_protocol
// - template image: remove_protocol


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/url-util/lib/index.js
// module id = 21
// module chunks = 0